import React from "react";
import {
  Button,
  InputAdornment,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

import CrmShell from "../components/CrmShell";
import { CrmPageHeader, CrmPanel, OwnerCell, StatusChip, crmUi } from "../components/CrmUi";
import { contacts } from "../demoData";

const CrmContactsPage = () => (
  <CrmShell>
    <CrmPageHeader
      title="Kontakter"
      subtitle="Personer kopplade till kunder, partners, leverantörer och andra organisationer."
      actions={[
        <Button key="new" size="small" variant="contained" startIcon={<AddOutlinedIcon />} sx={{ textTransform: "none" }}>
          Ny kontakt
        </Button>,
      ]}
    />

    <CrmPanel sx={{ overflow: "hidden" }}>
      <Stack direction={{ xs: "column", sm: "row" }} spacing={0.8} sx={{ p: 1.15, borderBottom: `1px solid ${crmUi.border}` }}>
        <TextField
          size="small"
          placeholder="Sök kontakter..."
          sx={{ flex: 1 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchOutlinedIcon sx={{ fontSize: 17 }} />
              </InputAdornment>
            ),
          }}
        />
        <Button variant="outlined" sx={{ textTransform: "none" }}>Filter</Button>
      </Stack>

      <TableContainer>
        <Table size="small" sx={{ minWidth: 900 }}>
          <TableHead>
            <TableRow sx={{ bgcolor: "#fbfcfd" }}>
              {["Kontakt", "Organisation", "Titel", "E-post", "Telefon", "Ansvarig", "Senaste aktivitet", "Status"].map(x => (
                <TableCell key={x} sx={{ py: 0.9, color: crmUi.muted, fontSize: 9.6, fontWeight: 550 }}>{x}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {contacts.map(contact => (
              <TableRow key={contact.id} hover>
                <TableCell>
                  <Typography sx={{ color: crmUi.text, fontSize: 11, fontWeight: 520 }}>{contact.name}</Typography>
                </TableCell>
                <TableCell sx={{ fontSize: 10.5 }}>{contact.organization}</TableCell>
                <TableCell sx={{ fontSize: 10.5 }}>{contact.title}</TableCell>
                <TableCell sx={{ fontSize: 10.3, color: "primary.main" }}>{contact.email}</TableCell>
                <TableCell sx={{ fontSize: 10.3 }}>{contact.phone}</TableCell>
                <TableCell><OwnerCell name={contact.owner} /></TableCell>
                <TableCell sx={{ fontSize: 10.2, color: crmUi.muted }}>{contact.lastActivity}</TableCell>
                <TableCell><StatusChip status={contact.status} /></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </CrmPanel>
  </CrmShell>
);

export default CrmContactsPage;
